<div class="p-4">
    <app-page-heading [title]="title"></app-page-heading>
</div>